<template>
  <div class="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 py-8 px-4 flex flex-col items-center">
    <div class="max-w-4xl w-full mx-auto space-y-6">
      
      <!-- Header -->
      <div class="flex items-center justify-between mb-4">
        <button @click="$router.back()" class="text-gray-300 hover:text-cyan-400 font-medium">
          ← Volver
        </button>
        <h1 class="text-xl font-bold text-white">Políticas y Condiciones</h1>
        <div class="w-20"></div>
      </div>

      <!-- Contenedor -->
      <div class="bg-gray-800 rounded-3xl shadow-2xl border border-gray-700 relative" style="height: 80vh;">
        
        <!-- IFRAME NATIVO DEL NAVEGADOR (Axios NO puede tocar esto) -->
        <iframe 
          v-if="iframeSrc"
          :src="iframeSrc" 
          class="w-full h-full border-0 rounded-3xl"
          type="application/pdf"
        ></iframe>

        <!-- Fallback si no hay URL -->
        <div v-else class="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
          <p class="text-gray-400 mb-4">No se encontró el documento.</p>
          <button @click="$router.back()" class="px-6 py-2 bg-gray-700 text-white rounded-xl">Volver</button>
        </div>

      </div>

      <!-- Botón de emergencia por si el navegador bloquea el iframe -->
      <div v-if="iframeSrc" class="text-center">
        <a 
          :href="originalUrl" 
          target="_blank" 
          class="text-cyan-400 hover:text-lime-400 underline text-sm"
        >
          ¿No se ve el PDF? Haz clic aquí para abrirlo en una pestaña nueva
        </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PoliticasView',
  data() {
    return {
      originalUrl: '',
      iframeSrc: ''
    }
  },
  created() {
    // 1. Obtenemos la URL cruda que guardó el botón
    this.originalUrl = sessionStorage.getItem('policyPdfUrl') || '';
    
    // 2. Si existe, construimos la URL absoluta a NUESTRO proxy
    if (this.originalUrl) {
      // window.location.origin garantiza que empiece con "https://tourpass.toursolutions.cl"
      // Al ser una cadena de texto asignada al src, Axios NO puede interceptarla.
      this.iframeSrc = window.location.origin + '/proxy-pdf?url=' + encodeURIComponent(this.originalUrl);
      
      console.log('✅ URL DEL IFRAME LISTA:', this.iframeSrc);
    }
  }
}
</script>